(() => {
  'use strict';
  const launcher = document.getElementById('cabane-loyalty-launcher');
  const panel = document.getElementById('cabane-loyalty-dialog');
  if (!launcher || !panel || typeof panel.showModal !== 'function') return;
  let handoff = false;
  let timer;
  const open = () => {
    if (!panel.open) panel.showModal();
    launcher.setAttribute('aria-expanded', 'true');
  };
  launcher.addEventListener('click', open);
  panel.querySelector('.cl-close').addEventListener('click', () => panel.close());
  panel.addEventListener('close', () => {
    launcher.setAttribute('aria-expanded', 'false');
    if (!handoff) launcher.focus();
  });
  panel.addEventListener('click', event => {
    if (event.target !== panel) return;
    const rect = panel.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) panel.close();
  });
  panel.querySelectorAll('[data-cl-smile]').forEach(link => link.addEventListener('click', () => {
    clearTimeout(timer);
    handoff = true;
    panel.querySelector('.cl-error').hidden = true;
    panel.close();
    timer = setTimeout(() => {
      const frame = document.querySelector('.smile-panel-frame-container');
      const shown = frame && frame.getBoundingClientRect().width > 0 && getComputedStyle(frame).visibility !== 'hidden' && getComputedStyle(frame).display !== 'none' && getComputedStyle(frame).opacity !== '0';
      handoff = false;
      if (!shown) {
        panel.querySelector('.cl-error').hidden = false;
        open();
      }
    }, 12000);
  }));
  document.documentElement.classList.add('cabane-rewards-ready');
  launcher.hidden = false;
  const tracked = new WeakSet();
  const styleFrame = frame => {
    let doc;
    try { doc = frame.contentDocument; } catch { return; }
    if (!doc?.head || doc.getElementById('cabane-rewards-smile')) return;
    const link = doc.createElement('link');
    link.id = 'cabane-rewards-smile';
    link.rel = 'stylesheet';
    link.href = panel.dataset.smileStyle;
    doc.head.appendChild(link);
  };
  const track = frame => {
    if (tracked.has(frame)) return;
    tracked.add(frame);
    frame.addEventListener('load', () => styleFrame(frame));
    styleFrame(frame);
  };
  const scan = node => {
    if (node.nodeType !== 1) return;
    if (node.matches('iframe.smile-panel-frame')) track(node);
    node.querySelectorAll('iframe.smile-panel-frame').forEach(track);
  };
  scan(document.body);
  new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(scan))).observe(document.body, {childList:true,subtree:true});
})();
